import { ADPResourceService } from 'digital-core';
import { Component } from '@angular/core';

@Component({
  selector: 'pgh-under-maintenance',
  templateUrl: './under-maintenance.component.html',
  styleUrl: './under-maintenance.component.scss'
})
export class UnderMaintenanceComponent  {
constructor(
    private resourceService: ADPResourceService,
  ) { }

}
